"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessages = exports.getError = void 0;
function getError(id, errors) {
    return (errors.find(function (error) { return error.id === id; }) || { message: undefined })
        .message;
}
exports.getError = getError;
function getErrorMessages(errors, errorCodesMap) {
    return errors.map(function (_a) {
        var id = _a.id, message = _a.message;
        return ({
            id: id,
            message: errorCodesMap[message],
        });
    });
}
exports.getErrorMessages = getErrorMessages;
